export const LoaderSpinner = () => {
  return (
    <div className="w-12 h-12 rounded-full animate-spin border-y-4 border-solid border-blue-500 border-t-transparent shadow-md" />
  );
};
